import { SAVE_ROLE } from './actionType'

export function saveRole(data) {
  return {
    type: SAVE_ROLE,
    data,
  }
}
